module.exports = __webpack_public_path__ + "static/img/7-3.2ac6bea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/7-3.jpg
// module id = JGDx
// module chunks = 0